import {
  TSnmpPacketList,
  useGetSnmpPackets,
} from 'api/packets/getSnmpPacketList'
import { QueryPaginated } from 'components/common'
import { useTranslation } from 'react-i18next'
import { RiRedPacketLine } from 'react-icons/ri'
import { SnmpPacketTable } from 'views/panel/SNMP/Single/components/SnmpPacketList'

export const SnmpPacketList = () => {
  const { t } = useTranslation()
  const query = useGetSnmpPackets()

  return (
    <QueryPaginated.Wrapper query={query}>
      <QueryPaginated.Data>
        {(data: TSnmpPacketList) => (
          <SnmpPacketTable noShadow data={data.items} />
        )}
      </QueryPaginated.Data>
      <QueryPaginated.NoData
        icon={RiRedPacketLine}
        title={t('packet.noData')}
      />
    </QueryPaginated.Wrapper>
  )
}
